import { render, staticRenderFns } from "./BackupAllocation.vue?vue&type=template&id=fd9fa140"
import script from "./BackupAllocation.vue?vue&type=script&lang=js"
export * from "./BackupAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports